<template>
	<div class="panel_shouyin">
		<div class="titleLine">
			<el-row>
				<el-col :span="6" style="padding:20px 20px;font-size: 16px;color:#333;">
					押金充值
				</el-col>
				<el-col :span="3" :offset="15" style="padding:10px 10px;">
					<el-button @click="back" size="mini" style="margin-left:40px;">返回</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="con">
			<el-row style="padding:0px 40px 10px;background-color: #ffffff;line-height: 40px;width:100%;" >
				<el-col :span="24">
					<span>金额：</span>
					<span class="rechargeBox">
						<el-input v-model="price" @input="inputPrice" size="mini"></el-input>
					</span>
				</el-col>
			</el-row>
			<!-- <el-row style="padding:0px 40px 10px;background-color: #ffffff;line-height: 40px;width:100%;" >
				<el-col :span="24">
					<span>销售人员：</span>
					<span>
						<el-select class="select" style="width:300px;" multiple v-model="curStaff" filterable placeholder="请选择" size="mini">
							<el-option popper-class="select" v-for="(item,index) in staffList" :key="item._id" :label="item.basic_info.nick_name"
							:value="index">
							</el-option>
						</el-select>
					</span>
				</el-col>
			</el-row> -->
		</div>
		<div class="panel_settlement">
			<div style="padding-top:7px;">
				
			</div>
			<div>
				<span class="priceItem" style="margin-right: 20px;">
					<span class="label">应付金额：</span>
					<span class="price" style="color:#FF2F2F;">￥{{price||0}}</span>
				</span>
				<el-button style="width:80px;" type="warning" size="small" plain @click="openBeizhu">备注</el-button>
				<el-button style="width:100px;" type="warning" size="small" plain @click="submitOrder">生成订单</el-button>
				<el-button style="width:80px;" type="warning" size="small" @click="submitOrderAndSettlement">结算</el-button>
			</div>
		</div>
		<!-- 备注弹窗 -->
		<div v-if="drawerRemark_state">
			<drawerRemark :type="'yajin'" @submit="submit_drawerRemark"></drawerRemark>
		</div>
		<!-- 结算弹窗 -->
		<div>
			<dialogSettlement v-if="dialogSettlementState" :type="'yajin'" :canYue="false" :orderId="order._id" @submit="dialogSettlementSubmit"></dialogSettlement>
		</div>
	</div>
</template>
<script>
	import dialogSettlement from "../../../../components/dialog_settlement.vue"
	import drawerRemark from "../drawer/remark.vue"
	export default {
		components:{dialogSettlement,drawerRemark},
		data(){
			return{
				price:'',
				// 备注
				drawerRemark_state:'',
				// 结算
				dialogSettlementState:false,
				order:{},
				// 是否直接结算
				direct:false,
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			remark(){
				return this.$store.state.yajin.remark;
			},
		},
		mounted(){
			
		},
		methods: {
			back(){
				this.$store.commit('yajin/set_type','list')
			},
			inputPrice(){
				this.price = this.$public.replaceGoodsDosage(this.price);
			},
			submitOrderAndSettlement(){
				this.direct = true;
				this.submitOrder();
			},
			// 提交
			submitOrder() {
				if (this.$public.isNull(this.price)) {
					this.$message({
						message: '金额数据有误！！',
						type: 'error'
					});
					return;
				}
				let params = {
					"price": this.price,
					"memberId": this.userInfo._id,
					"memberName": this.userInfo.basic_info.nick_name,
					remark:this.remark,
				}
				let loading = this.$loading();
				this.$http.get('/api/Recharge/YajinRecharge', params).then(res => {
					loading.close()
					if (res.code == 0) {
						if(this.direct){
							this.order = res.data;
							this.dialogSettlementState = true;
						}else{
							this.$message({
								message: '操作成功',
								type:'success'
							});
							this.$store.commit('yajin/set_type','list')
						}
					}
				})
			},
			// 结算
			dialogSettlementSubmit(a){
				this.dialogSettlementState = false;
				if(a=='cancel'){
					console.log(a)
				}else if(a=='fail'){
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				}else if(a=='success'){
					this.$message({
						message: '结算成功',
						type: 'success'
					});
					this.$store.dispatch("mendian/getUserInfo",this.userInfo._id)
					this.$store.commit('yajin/set_type','list')
				}
			},
			// 备注
			openBeizhu(){
				this.drawerRemark_state=true;
			},
			submit_drawerRemark(){
				this.drawerRemark_state=false;
			},
		}
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	background-color: #fff;height: 100%;position: relative;
	.titleLine{
		width:100%;box-sizing: border-box;position: absolute;top:0;z-index: 1;background-color: #fff;
	}
	.con{
		height: 100%;padding:60px 0 60px 0;overflow: auto;box-sizing: border-box;
		.rechargeBox{
			display: inline-flex;flex-wrap: wrap;
			.rechargeItem{
				position: relative;width:172px;box-sizing: border-box;text-align: center;line-height: 38px;color:#000;font-size: 16px;background-color: #E8E8E8;border-radius: 2px;margin-top:15px;margin-right:20px;border:1px solid transparent;cursor: pointer;
				&.active{
					background-color: #E3F2FF;border-color:#1890FF;
				}
				.checked{
					position: absolute;right:0;bottom:0;width:26px;height: 13px;text-align: center;color:#fff;
				}
			}
		}
	}
	.msg{
		display: flex;
		flex-wrap: wrap;
		padding:0 30px;
		background-color: #fff;
		.msgItem{
			width:280px;
			font-size: 16px;
			color:#1A1A1A;
			display: flex;
			line-height: 50px;;
			.msgLabel{
				width:120px;
				text-align: right;
				color:#999999;
			}
			.msgValue{
				
			}
		}
	}
	.pageConBox{
		padding:0 20px;
		min-height: 600px;
	}
	.panel_settlement{
		position: absolute;
		z-index: 110;
		bottom:0;
		width:100%;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		padding:10px 20px;
		background-color: #fff;
		box-shadow: 0 -3px 3px 0px #f5f5f5;
		.priceItem{
			display: inline-flex;align-items: center;
			margin-right: 40px;
			.label{
				font-size: 14px;color:$fontColor;
			}
			.price{
				font-size: 20px;color:$fontColor;
			}
		}
	}
}
</style>
